import * as React from 'react'
import PropTypes from 'prop-types'
import { NavigationMenu } from '../navigation-menu/navigation-menu'
import { AppBar } from '../app-bar/app-bar'
import styles from './pages-container.scss'

export class PagesContainer extends React.Component {

    static propTypes = {
        children: PropTypes.node
    }

    render() {
        return (
            <div id="pagesContainer" className={styles.pagesContainer}>
                <NavigationMenu/>
                <div className={styles.pageWithAppBar}>
                    <AppBar/>
                    <div id="pageContent" className={styles.pageContent}>
                        <div className={styles.page}>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
